"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
// This seems to be accessible everywhere so no need to change this
// for different environments
const FONT_BASE = "https://static.buoyhealth.com/fonts/";
// GT Eesti Display (primary font)
const GTEestiRegularWoff2 = `${FONT_BASE}GT-Eesti-Display-Regular.woff2`;
const GTEestiRegularWoff = `${FONT_BASE}GT-Eesti-Display-Regular.woff`;
const GTEestiRegularOTF = `${FONT_BASE}GT-Eesti-Display-Regular.otf`;
const GTEestiRegularItalicWoff2 = `${FONT_BASE}GT-Eesti-Display-Regular-Italic.woff2`;
const GTEestiRegularItalicWoff = `${FONT_BASE}GT-Eesti-Display-Regular-Italic.woff`;
const GTEestiRegularItalicOTF = `${FONT_BASE}GT-Eesti-Display-Regular-Italic.otf`;
const GTEestiBoldWoff2 = `${FONT_BASE}GT-Eesti-Display-Bold.woff2`;
const GTEestiBoldWoff = `${FONT_BASE}GT-Eesti-Display-Bold.woff`;
const GTEestiBoldOTF = `${FONT_BASE}GT-Eesti-Display-Bold.otf`;
// Spectral (secondary font)
const SpectralLight = `${FONT_BASE}Spectral-Light.ttf`;
const SpectralRegular = `${FONT_BASE}Spectral-Regular.ttf`;
const SpectralItalic = `${FONT_BASE}Spectral-Italic.ttf`;
const SpectralBold = `${FONT_BASE}Spectral-Bold.ttf`;
/*
  WOFF2 - Super Modern Browsers - first reference always gets loaded first, so we preload this
  WOFF - Pretty Modern Browsers
  OTF - Safari, Android, iOS
*/
exports.default = (0, styled_components_1.createGlobalStyle) `
  @font-face {
    font-family: 'GT Eesti Display';
    src: url(${GTEestiRegularWoff2}) format('woff2'),
      url(${GTEestiRegularWoff}) format('woff'),
      url(${GTEestiRegularOTF}) format('opentype');
    font-weight: 400;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Eesti Display';
    src: url(${GTEestiRegularItalicWoff2}) format('woff2'),
      url(${GTEestiRegularItalicWoff}) format('woff'),
      url(${GTEestiRegularItalicOTF}) format('opentype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: 'GT Eesti Display';
    src: url(${GTEestiBoldWoff2}) format('woff2'),
      url(${GTEestiBoldWoff}) format('woff'),
      url(${GTEestiBoldOTF}) format('opentype');
    font-weight: 600;
    font-display: swap;
  }
  @font-face {
    font-family: 'Spectral';
    src: url(${SpectralLight}) format('truetype');
    font-weight: 300;
    font-display: swap;
  }
  @font-face {
    font-family: 'Spectral';
    src: url(${SpectralRegular}) format('truetype');
    font-weight: 400;
    font-display: swap;
  }
  @font-face {
    font-family: 'Spectral';
    src: url(${SpectralItalic}) format('truetype');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
  }
  @font-face {
    font-family: 'Spectral';
    src: url(${SpectralBold}) format('truetype');
    font-weight: 700;
    font-display: swap;
  }
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
  }
`;
//# sourceMappingURL=index.js.map